var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-page-base", { attrs: { title: "Logs" } }, [
    _c(
      "div",
      { staticClass: "page-logs__wrap-content" },
      _vm._l(_vm.logs, function(log, index) {
        return _c(
          "section",
          { key: index, staticClass: "page-logs__wrap-content__item" },
          [
            _c(
              "sc-card",
              { staticClass: "page-logs__card", attrs: { link: true } },
              [
                _c("template", { attrs: { slot: "image" }, slot: "image" }, [
                  _c(
                    "figure",
                    { staticClass: "page-logs__card__figure" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "page-logs__card__link",
                          attrs: { to: { name: log.pathName } }
                        },
                        [
                          _c("img", {
                            staticClass: "page-logs__card__image",
                            attrs: { src: log.image }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                  _c("div", { staticClass: "page-logs__card__content" }, [
                    _c(
                      "p",
                      { staticClass: "title is-6" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "page-logs__card__full-link",
                            attrs: { to: { name: log.pathName } }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "has-text-truncated page-logs__card__full-link__text"
                              },
                              [_vm._v(_vm._s(log.title))]
                            ),
                            _vm._v(" "),
                            _c("sc-icon", { attrs: { icon: log.icon } })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ],
              2
            )
          ],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-554da9b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-554da9b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/PageLogs.vue
// module id = null
// module chunks = 